<template>
  <div class="li-error-page">
    <div>
      <img :src="img" />
    </div>
    <div class="li-error-content">
      <div>
        <h1 class="title">{{ title }}</h1>
        <p class="message">{{ message }}</p>
      </div>
      <a-button @click="returnPage">返回</a-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router'
const router = useRouter()
defineProps({
  img: String,
  message: String,
  title: String,
})

const returnPage = () => {
  router.go(-1)
}
</script>
<style scoped lang="less">
.li-error-page {
  height: 100%;
  min-width: 900px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  .li-error-content {
    margin-left: 50px;
    .title {
      margin: 0;
      font-size: 100px;
      color: #ff6565;
    }
  }
}
</style>
